import { useEffect, useState } from 'react'
import { getModelEfforts } from './ModelSelector.js'

/** Shared localStorage key so the reasoning-variant choice carries across
 *  surfaces (ChatPanel + HeroChat). */
const REASONING_VARIANT_KEY = 'papan-agent-reasoning-variant'

/**
 * Reasoning-effort variant (@sync OpenCode model.variant). 'default' = Auto =
 * provider default. Persisted under a single key; reset when the selected model
 * doesn't support the current variant. Shared by ChatPanel and HeroChat.
 */
export function useReasoningVariant(selectedModel: string): {
  reasoningVariant: string
  selectReasoningVariant: (v: string) => void
} {
  const [reasoningVariant, setReasoningVariant] = useState<string>(() =>
    (typeof localStorage !== 'undefined' && localStorage.getItem(REASONING_VARIANT_KEY)) || 'default')
  const selectReasoningVariant = (v: string) => {
    setReasoningVariant(v)
    try { localStorage.setItem(REASONING_VARIANT_KEY, v) } catch { /* ignore */ }
  }
  useEffect(() => {
    if (reasoningVariant !== 'default' && !getModelEfforts(selectedModel).includes(reasoningVariant)) {
      // Persist the reset too (not just setState) — otherwise the stale, now-invalid
      // variant stays in localStorage and is re-read on the next reload. (#244 review.)
      selectReasoningVariant('default')
    }
  }, [selectedModel, reasoningVariant])
  return { reasoningVariant, selectReasoningVariant }
}
